// pages/AddJewelleryPage.js
import React, { useState } from 'react';
import api from '../api';
import '../styles/AddJewelleryPage.css';

const AddJewelleryPage = () => {
  const [formData, setFormData] = useState({
    itemName: '',
    weight: '',
    weightUnit: 'gm',
    quantity: '',
    ratePerQuantity: '',
    finalAmount: '',
    gst: ''
  });

  const onChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post('/jewellery/add', formData);
      alert('Jewellery added successfully');
    } catch (error) {
      console.error('Error adding jewellery:', error.message);
    }
  };

  return (
    <div className="add-jewellery-container">
      <h2>Add Jewellery</h2>
      <form onSubmit={onSubmit}>
        <div className="form-group">
          <label>Item Name</label>
          <input type="text" name="itemName" value={formData.itemName} onChange={onChange} required />
        </div>
        <div className="form-group">
          <label>Weight</label>
          <input type="number" name="weight" value={formData.weight} onChange={onChange} required />
        </div>
        <div className="form-group">
          <label>Weight Unit</label>
          <select name="weightUnit" value={formData.weightUnit} onChange={onChange} required>
            <option value="gm">gm</option>
            <option value="kg">kg</option>
          </select>
        </div>
        <div className="form-group">
          <label>Quantity</label>
          <input type="number" name="quantity" value={formData.quantity} onChange={onChange} required />
        </div>
        <div className="form-group">
          <label>Rate Per Quantity</label>
          <input type="number" name="ratePerQuantity" value={formData.ratePerQuantity} onChange={onChange} required />
        </div>
        <div className="form-group">
          <label>Final Amount</label>
          <input type="number" name="finalAmount" value={formData.finalAmount} onChange={onChange} required />
        </div>
        <div className="form-group">
          <label>GST</label>
          <input type="number" name="gst" value={formData.gst} onChange={onChange} required />
        </div>
        <button type="submit">Add Jewellery</button>
      </form>
    </div>
  );
};

export default AddJewelleryPage;
